export enum OrderStatus {
  DRAFT = 'DRAFT', // Borrador
  CONFIRMED = 'CONFIRMED', // Confirmado
  IN_KITCHEN = 'IN_KITCHEN', // En cocina
  READY_TO_SERVE = 'READY_TO_SERVE', // Listo para servir
  COMPLETED = 'COMPLETED', // Completado
  INVOICED = 'INVOICED', // Facturado (incluido en una factura)
  CANCELLED = 'CANCELLED', // Cancelado
}

export const ORDER_STATUS_LABELS = {
  [OrderStatus.DRAFT]: 'Borrador',
  [OrderStatus.CONFIRMED]: 'Confirmado',
  [OrderStatus.IN_KITCHEN]: 'En cocina',
  [OrderStatus.READY_TO_SERVE]: 'Listo para servir',
  [OrderStatus.COMPLETED]: 'Completado',
  [OrderStatus.INVOICED]: 'Facturado',
  [OrderStatus.CANCELLED]: 'Cancelado',
};
